<template lang="pug">
#more
  .head_menu.i_pt_8.i_pb_10
    .container.d-none.d-lg-flex.justify-content-between
      .left.flex_v
        .search
          ul
            li 熱門搜尋
            li.flex_h
              ul.search_item(
                v-if="index % 3 == 0",
                v-for="(word, index) in hotKeyword.HotKeywordList"
              )
                li(
                  v-for="(word, sonIndex) in hotKeyword.HotKeywordList",
                  v-if="sonIndex >= index && sonIndex < index + 3"
                )
                  p(
                    v-if="word.HotKeywordProductJson == '-1'",
                    @click="toCustomize(word.CustomizeJson)"
                  ) {{ word.HotKeywordTitle }}
                  p(v-else, @click="toProduct(word.HotKeywordProductJson)") {{ word.HotKeywordTitle }}
        .options.flex_h
          ul
            li 網站導覽與聲明
            li
              p(@click="toPage('Sitemap')") 網站地圖
            li
              p(@click="toPage('CustomerProtectionStatement')") 客戶保護及聲明事項
            li
              p(@click="toCustomize('Trafficsafetyzone')") 交通安全宣導專區
            li
              p(@click="toUrl('https://easyaccess.tmnewa.com.tw/')") 友善服務網站

          ul
            li 加入我們
            li 
              p(
                @click="toUrl('https://www.104.com.tw/company/7qey3yw?jobsource=n104bank1')"
              ) 菁英招募
            li
              a(href="https://www.facebook.com/tmnewa", target="_blank")
                font-awesome-icon(:icon="['fab', 'facebook-square']")
            li 
              a(
                href="https://www.youtube.com/channel/UCmfkEx42CLQFVF0r1PYsojg",
                target="_blank"
              )
                font-awesome-icon(:icon="['fab', 'youtube']")
      .right.d-flex.justify-content-between
        ul
          li 網路投保
          li(v-for="link in siteMap.WebInsuredList")
            p(@click="toUrl(link.URL)") {{ link.Name }}
        ul
          li 商品櫥窗
          li(v-for="product in productCategory.ProductCategoryList") 
            p(@click="toPageWindow(product)") {{ product.ProductCategoryName }}
        ul
          li 客戶服務
          li 
            p(@click="toPage('CustomerServiceClaimSettlement')") 理賠服務
          li 
            p(@click="toPage('CustomerServicePaymentService')") 繳費服務
          li 
            p(@click="toPage('CustomerServiceDamagePrevention')") 損害防損
          li 
            p(@click="toPage('CustomerServiceEInsurance')") 電子保單下載
          li 
            p(@click="toPage('CustomerServiceCompulsoryLicense')") 強制證下載
          li 
            p(@click="toPage('CustomerServiceFAQ')") 常見問題
          li 
            p(@click="toPage('CustomerServiceDocumentDownload')") 文件下載
          //- li(v-if="false")
          li
            p(@click="toPage('CustomerServiceContactUs')") 聯絡我們
          li
            p(
              @click="toUrl('https://www.tmnewa.com.tw/b2c_v2/commonweb/claim/car/index.html')"
            ) 車險理賠服務平台
        ul
          li 認識我們
          li 
            p(@click="toPage('AboutUsProfile')") 公司簡介
          li 
            p(@click="toPage('AboutUsSocialResponsibility')") 永續發展
          li 
            p(@click="toPage('AboutUsPublicInfo')") 公開資訊
          li 
            p(@click="toPage('AboutUsGovernance')") 公司治理
          li
            a(href="/customize/Stewardship") 盡職治理
          li 
            p(@click="toPage('AboutUsNews')") 最新消息
          li 
            p(@click="toPage('CustomerServiceContactUs')") 商業合作
          li
            p(@click="toPage('ShareholderServices')") 股東專區
          li
            a(href="/customize/manager") 公平待客
        .last_list.d-flex.flex-column.justify-content-between
          ul
            li 友站連結
            li(v-for="link in siteMap.LinkList")
              p(@click="toUrl(link.URL)") {{ link.Name }}
          ul.lang
            li
              svg-icon.i_ml_1.i_ml_md_0.i_ml_sm_1(
                iconClass="lang",
                className="lang_icon"
              )
              span 切換網站顯示語言
            li 
              span(style="cursor: pointer", @click="toPage('Home')") 中文
              | /
              span(style="cursor: pointer", @click="toPage('Japanese')") 日本語
              | /
              span(style="cursor: pointer", @click="toPage('English')") EN
    .container.d-lg-none
      .group.d-flex
        ul.d-none.d-md-block
          li 熱門搜尋
            li(v-for="word in hotKeyword.HotKeywordList")
              p(
                v-if="word.HotKeywordProductJson == '-1'",
                @click="toCustomize(word.CustomizeJson)"
              ) {{ word.HotKeywordTitle }}
              p(v-else, @click="toProduct(word.HotKeywordProductJson)") {{ word.HotKeywordTitle }}
        ul
          li 網路投保
          li(v-for="link in siteMap.WebInsuredList")
            p(@click="toUrl(link.URL)") {{ link.Name }}
        ul
          li 商品櫥窗
          li(v-for="product in productCategory.ProductCategoryList") 
            p(@click="toPageWindow(product)") {{ product.ProductCategoryName }}
        ul
          li 客戶服務
          li 
            p(@click="toPage('CustomerServiceClaimSettlement')") 理賠服務
          li 
            p(@click="toPage('CustomerServicePaymentService')") 繳費服務
          li 
            p(@click="toPage('CustomerServiceDamagePrevention')") 損害防損
          li 
            p(@click="toPage('CustomerServiceEInsurance')") 電子保單下載
          li 
            p(@click="toPage('CustomerServiceCompulsoryLicense')") 強制證下載
          li 
            p(@click="toPage('CustomerServiceFAQ')") 常見問題
          li 
            p(@click="toPage('CustomerServiceDocumentDownload')") 文件下載
          li
            p(@click="toPage('CustomerServiceContactUs')") 聯絡我們
          li
            p(
              @click="toUrl('https://www.tmnewa.com.tw/b2c_v2/commonweb/claim/car/index.html')"
            ) 車險理賠服務平台
        ul.d-none.d-md-block
          li 認識我們
          li 
            p(@click="toPage('AboutUsProfile')") 公司簡介
          li 
            p(@click="toPage('AboutUsSocialResponsibility')") 永續發展
          li 
            p(@click="toPage('AboutUsPublicInfo')") 公開資訊
          li 
            p(@click="toPage('AboutUsGovernance')") 公司治理
          li
            a(href="/customize/Stewardship") 盡職治理
          li 
            p(@click="toPage('AboutUsNews')") 最新消息
          li 
            p(@click="toPage('CustomerServiceContactUs')") 商業合作
          li
            p(@click="toPage('ShareholderServices')") 股東專區
          li
            a(href="/customize/manager") 公平待客
        ul.d-none.d-md-block
          li 加入我們
          li 
            p(
              @click="toUrl('https://www.104.com.tw/company/7qey3yw?jobsource=n104bank1')"
            ) 菁英招募
            li
              a(href="https://www.facebook.com/tmnewa", target="_blank")
                font-awesome-icon(:icon="['fab', 'facebook-square']")
            li 
              a(
                href="https://www.youtube.com/channel/UCmfkEx42CLQFVF0r1PYsojg",
                target="_blank"
              )
                font-awesome-icon(:icon="['fab', 'youtube']")
        ul.d-none.d-md-block
          li 網站導覽與聲明
          li
            p(@click="toPage('Sitemap')") 網站地圖
          li
            p(@click="toPage('CustomerProtectionStatement')") 客戶保護及聲明事項
          li
            p(@click="toCustomize('Trafficsafetyzone')") 交通安全宣導專區
          li
            a(href="https://easyaccess.tmnewa.com.tw/", target="_blank") 友善服務網站
        ul.d-md-none
          li 熱門搜尋
            li(v-for="word in hotKeyword.HotKeywordList")
              p(
                v-if="word.HotKeywordProductJson == '-1'",
                @click="toCustomize(word.CustomizeJson)"
              ) {{ word.HotKeywordTitle }}
              p(v-else, @click="toProduct(word.HotKeywordProductJson)") {{ word.HotKeywordTitle }}
        .last_list.d-flex.flex-column.justify-content-between
          ul.d-none.d-md-block
            li 友站連結
            li(v-for="link in siteMap.LinkList")
              p(@click="toUrl(link.URL)") {{ link.Name }}
          ul.lang.text-center.text-md-left
            li.d-none.d-md-block
              svg-icon.i_ml_1.i_ml_md_0.i_ml_sm_1(
                iconClass="lang",
                className="lang_icon"
              )
              span 切換網站顯示語言
            li 
              svg-icon.d-md-none.i_ml_1.i_ml_md_0.i_ml_sm_1(
                iconClass="lang",
                className="lang_icon"
              )
              span 中文
              | /
              span(@click="toPage('Japanese')") 日本語
              | /
              span(@click="toPage('English')") EN
</template>

<script>
import { getSiteMap, getHotKeyword } from "@/json/menu";
import { getProductCategory } from "@/json/product";

export default {
  name: "More",

  data() {
    return {
      siteMap: {},
      hotKeyword: {},
      productCategory: {},
    };
  },
  created() {
    this.getSiteMap();
    this.getHotKeyword();
    this.getProductCategory();
  },
  methods: {
    toPage(pageName) {
      this.$router.push({ name: pageName });
      this.$emit("menuExpand", false);
    },
    toUrl(url) {
      window.open(url);
      this.$emit("menuExpand", false);
    },
    getSiteMap() {
      getSiteMap().then((response) => {
        this.siteMap = response.data;
      });
    },
    getHotKeyword() {
      getHotKeyword().then((response) => {
        this.hotKeyword = response.data;
      });
    },
    getProductCategory() {
      getProductCategory().then((response) => {
        this.productCategory = response.data;
      });
    },
    toContactUs() {
      this.$router.push({ name: "CustomerServiceContactUs" });
      this.$emit("menuExpand", false);
    },
    toProduct(productJson) {
      this.$router.push({
        name: "ProductIntro",
        params: {
          type: productJson,
        },
      });
      if ("ProductIntro" == this.$route.name) {
        this.$emit("footerProductClick");
      }
      this.$emit("menuExpand", false);
    },
    toPageWindow(product) {
      if (product && product.ProductList.length > 0) {
        this.$router.push({
          name: "ProductIntro",
          params: {
            type: product.ProductList[0].ProductJson,
          },
        });
        if ("ProductIntro" == this.$route.name) {
          this.$emit("footerProductClick");
        }
        this.$emit("menuExpand", false);
      }
    },
    toCustomize(customizeJson) {
      this.$router.push({
        name: "Customize",
        params: {
          page: customizeJson,
        },
      });
      this.$emit("menuExpand", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/more";
</style>
